import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import auth from "./auth";
import env from "./env";

export default class SignonService {
  constructor($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout, $analytics) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$env = EnvService;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;

    this.signOnLoginUrl = "jbl/v1/login?format=json";
    this.signOnRegisterUrl = "register/register?format=json";
    this.connectUrl = "jbl/v1/connectedAccounts";
  }

  login(data, dataForLogin) {
    console.log("signon js");
    console.dir(data);
    console.dir(dataForLogin);

    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + this.signOnLoginUrl,
      data: {
        connectedAccountType: dataForLogin.connectedAccountType,
        connectedAccountToken: dataForLogin.connectedAccountToken,
      },
    };

    return this.$http(req);
  }

  register(data, dataForLogin) {
    var req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + this.signOnRegisterUrl,
      data: data,
    };

    return this.$http(req);
  }

  connect(data, user) {
    var req = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + user.access_token,
      },
      url: this.$env.getAPIEndPoint() + this.connectUrl,
      data: data,
    };

    return this.$http(req);
  }
}

SignonService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout", "$analytics"];



// WEBPACK FOOTER //
// ./client/app/services/signon.js